import { Card } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { usePermission } from "@/shared/hooks/usePermission";
import { useEmployeeZoneAssignments } from "../hooks/useEmployeeProfile";

/** `YYYY-MM-DD` → `DD.MM.YY` (kanvas shakli). */
function qisqaSana(qiymat: string): string {
	return dayjs(qiymat).format("DD.MM.YY");
}

/**
 * «Biriktirilgan hududlar» yon kartasi (kanvas, o'ng ustun).
 *
 * ⚠️ **`useEmployeeZoneAssignments` QAYTA ISHLATILADI** — sarlavhadagi
 * fakt ustuni bilan AYNI kesh kaliti (`["employees","zones",id]`), ya'ni
 * ikkinchi so'rov ketmaydi.
 *
 * ⚠️⚠️ **Klientda QAYTA SARALANMAYDI.** Kontrakt aniq: javob SERVER
 * tartibida chiziladi. «Yakunlanganni pastga tushiraylik» refleksi shu
 * yerda xato bo'lardi — mijozda ikkinchi tartib qo'yilsa bu karta bilan
 * «Hududlar» yorlig'i (u ham server tartibida) JIMGINA ajralardi.
 * Yakunlangan qator RANG bilan ajratiladi, POZITSIYA bilan emas.
 *
 * ⚠️⚠️ **Yakunlangan biriktirish YASHIRILMAYDI.** `employee_zones` —
 * APPEND-ONLY (CLAUDE.md): `DELETE` qator o'chirmaydi, `valid_to`
 * qo'yadi. O'tgan oy davomati o'sha davrda amalda bo'lgan biriktirish
 * bo'yicha hisoblanadi, ya'ni tarix — hisobning bir qismi. Ostidagi
 * izoh buni o'quvchiga aytadi va u MAJBURIY.
 */
export function EmployeeZonesCard({ employeeId }: { employeeId: string }) {
	const { t } = useTranslation("employees");
	const { can } = usePermission();
	const { data = [] } = useEmployeeZoneAssignments(employeeId);

	if (!can("zones", "read")) {
		return null;
	}

	return (
		<Card title={t("zonesCard.title")}>
			{data.length === 0 ? (
				<div className="text-xs text-[#8a929e]">{t("zonesCard.empty")}</div>
			) : (
				data.map((qator) => (
					<div
						key={qator.id}
						data-testid="zone-row"
						className={`flex items-baseline justify-between gap-2 border-b border-[#eeefec] py-2 text-sm last:border-b-0 ${
							qator.amalda ? "" : "opacity-60"
						}`}
					>
						<span className="min-w-0 truncate">{qator.zoneName}</span>
						<span className="whitespace-nowrap text-xs text-[#8a929e]">
							{qator.validTo
								? `${qisqaSana(qator.validFrom)} – ${qisqaSana(qator.validTo)}`
								: `${qisqaSana(qator.validFrom)} →`}
						</span>
					</div>
				))
			)}

			<div className="mt-3 text-xs text-[#8a929e]">{t("zonesCard.historyNote")}</div>
		</Card>
	);
}
